module.exports = __webpack_public_path__ + "img/26_164.65ab4db4.png";